import { useLocation, useNavigate } from "react-router-dom";
import FieldTeamStatusBoard from "./FieldTeamStatusBoard/FieldTeamStatusBoard";
import IpDonorStatusBoard from "./IpDonorStatusBoard/IpDonorStatusBoard";
import ReportingList from "./ReportingList/ReportingList";
import { RolesEnum } from "../../../services/rolesEnum";
import { isAuthorized } from "../../../services/authService";
import DataChecks from "./DataChecks/DataChecks";
import { Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import ApproveSiteVisits from "./approveSiteVisits/ApproveSiteVisits";
import { useEffect, useState } from "react";

const validPages = {
  "?siteVisitReportingList": "siteVisitReportingList",
  "?submittedForApproval": "siteVisitReportingList",
  "?SubmittedForApproval": "SubmittedForApproval",
  "?ApprovedVisits": "SubmittedForApproval",
  "?DataChecks": "DataChecks",
  "?FieldTeamStatusBoard": "FieldTeamStatusBoard",
  "?IpDonorStatusBoard": "IpDonorStatusBoard",
};

function Reporting() {
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("FieldTeamStatusBoard");
  const navigate = useNavigate();

  const handleTabChange = (key) => {
    navigate(`/project/reporting?${key}`);
  };

  useEffect(() => {
    setActiveKey(validPages[location.search]);
  }, [location]);

  return (
    <div className="planning-page p-0">
      <Tabs
        activeKey={activeKey}
        onChange={handleTabChange}
        type="card"
        className="card-tabs"
        destroyInactiveTabPane={true}
      >
        {isAuthorized([
          RolesEnum.ProjectManager,
          RolesEnum.SystemAdmin,
          RolesEnum.FieldCoordinator,
          RolesEnum.FieldTeamLeader,
          RolesEnum.FieldEnumerator,
          RolesEnum.FieldLogistics,
          RolesEnum.DataAnalyst,
        ]) && (
          <TabPane tab="Field Team Status Board" key="FieldTeamStatusBoard">
            <div className="insideTab">
              <FieldTeamStatusBoard />
            </div>
          </TabPane>
        )}
        {isAuthorized([
          RolesEnum.ProjectManager,
          RolesEnum.SystemAdmin,
          RolesEnum.FieldCoordinator,
          RolesEnum.FieldTeamLeader,
          RolesEnum.FieldEnumerator,
          RolesEnum.FieldLogistics,
          RolesEnum.DataAnalyst,
        ]) && (
          <TabPane tab="IP Donor Status Board" key="IpDonorStatusBoard">
            <div className="insideTab">
              <IpDonorStatusBoard />
            </div>
          </TabPane>
        )}
        {isAuthorized([
          RolesEnum.ProjectManager,
          RolesEnum.SystemAdmin,
          RolesEnum.FieldCoordinator,
          RolesEnum.FieldTeamLeader,
          RolesEnum.FieldLogistics,
          RolesEnum.DataAnalyst,
        ]) && (
          <TabPane
            tab="Visit Board Reporting List"
            key="siteVisitReportingList"
          >
            <div className="insideTab">
              <ReportingList />
            </div>
          </TabPane>
        )}
        {isAuthorized([RolesEnum.ProjectManager, RolesEnum.SystemAdmin, RolesEnum.LimitedGuest]) && (
          <TabPane tab="Data Checks" key="DataChecks">
            <DataChecks />
          </TabPane>
        )}
        {isAuthorized([RolesEnum.ProjectManager, RolesEnum.SystemAdmin]) && (
          <TabPane tab="Approve Site Visits" key="SubmittedForApproval">
            <ApproveSiteVisits />
          </TabPane>
        )}
      </Tabs>
    </div>
  );
}

export default Reporting;
